$('.links-are-popups a').on('click', function(e) {
  e.preventDefault();
  window.open(
    $(this).attr('href'),
    '_blank',
    'location=no,scrollbars=yes,status=no,toolbar=yes,resizable=yes'
  );
});

$('.toggle-edition').on('click', function(e) {
  e.preventDefault();

  const selector = $(this).attr('data-target');

  tinymce.init({
    selector: selector,
    content_css: false,
    skin: false,
    branding: false,
    menubar: false,
    statusbar: false,
    smart_paste: true,
    plugins: 'paste autoresize save lists textcolor colorpicker link table',
    toolbar: 'cancel save | undo redo | styleselect | bold italic | link | alignleft aligncenter alignright | numlist bullist | forecolor backcolor | table',
    save_enablewhendirty: false,
    save_oncancelcallback: () => location.reload(),
    setup: function (editor) {
      editor.on('init', function (e) {
        editor.getBody().style.fontFamily = 'Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif';
      });
    },
  });
  $(this).remove();
});
